exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/application/core-module/scora-common-module/scora-doc-pdf-view/scora-doc-pdf-view.component.css
// module id = 833
// module chunks = 6